import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router, RouterStateSnapshot
} from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { GoogleAuthenticationService } from '../../../core/login/google-authentication.service';

@Injectable()
export class AuthenticationGuard implements CanActivateChild {

  constructor(private readonly router: Router,
              private readonly googleAuthenticationService: GoogleAuthenticationService) {
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.googleAuthenticationService.isLoggedIn$.pipe(
      take(1), // Tomamos solo el primer valor y completamos la suscripción
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        }
        this.router.navigate(['/login']);
        return false;
      })
    );
  }
}
